// extracted by mini-css-extract-plugin
export default {"addNameInput":"Email_addNameInput__bxP1A"};